// import { Link } from "@inertiajs/react"
import type { PropsWithChildren } from "react"

import { usePage } from "@inertiajs/react"
import { AlertCircle, CheckCircle2 } from "lucide-react"

// import AppLogoIcon from "@/components/app-logo-icon"
import AppearanceToggleDropdown from "@/components/appearance-dropdown"
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert"
// import { rootPath } from "@/routes"

interface AuthLayoutProps {
  name?: string
  title?: string
  description?: string
}

export default function AuthSimpleLayout({
  children,
  title,
  description,
}: PropsWithChildren<AuthLayoutProps>) {
  const { flash } = usePage().props as any

  return (
    <div className="bg-background flex min-h-svh flex-col items-center justify-center gap-6 p-6 md:p-10">
      {/* Dark Mode Toggle - Top Right */}
      <div className="absolute top-4 right-4">
        <AppearanceToggleDropdown />
      </div>

      <div className="w-full max-w-sm">
        <div className="flex flex-col gap-8">
          <div className="flex flex-col items-center gap-4">
            <div className="space-y-2 text-center">
              <h1 className="text-xl font-medium">{title}</h1>
              <p className="text-muted-foreground text-center text-sm">
                {description}
              </p>
            </div>
          </div>

          {flash.alert && (
            <Alert variant="destructive">
              <AlertCircle className="h-4 w-4" />
              <AlertTitle>Error</AlertTitle>
              <AlertDescription>{flash.alert}</AlertDescription>
            </Alert>
          )}

          {flash.notice && (
            <Alert>
              <CheckCircle2 className="h-4 w-4" />
              <AlertTitle>Success</AlertTitle>
              <AlertDescription>{flash.notice}</AlertDescription>
            </Alert>
          )}

          {children}
        </div>
      </div>
    </div>
  )
}
